/**
 * Created by dineth on 25/06/2024.
 */
(function () {
  'use strict';

  angular
    .module('cycle')
    .controller('editRosterCycleCtrl', editRosterCycleCtrl);

  function editRosterCycleCtrl(MessageService,AdminCycleService, modalParams,$uibModalInstance) {
    var vm = this;

    vm.model = {
      cycleId : modalParams.cycleId,
      cycleName : modalParams.cycleName,
      dateFrom : modalParams.dateFrom,
      dateTo : modalParams.dateTo,
      fcBidDeadlineDate : modalParams.fcBidDeadlineDate,
      ccBidDeadlineDate : modalParams.ccBidDeadlineDate,
      insBidDeadlineDate : modalParams.insBidDeadlineDate,
      fcBidDeadlineTime : modalParams.fcBidDeadlineTime,
      ccBidDeadlineTime : modalParams.ccBidDeadlineTime,
      insBidDeadlineTime : modalParams.insBidDeadlineTime,
      crewGroupCode : modalParams.crewGroupCode,
      version : modalParams.version,
      ccSameAsCockpit : modalParams.ccBidDeadlineDate == modalParams.fcBidDeadlineDate && modalParams.ccBidDeadlineTime == modalParams.fcBidDeadlineTime,
      insSameAsCockpit : modalParams.insBidDeadlineDate == modalParams.fcBidDeadlineDate && modalParams.insBidDeadlineTime == modalParams.fcBidDeadlineTime
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    }
    vm.sameAsCockpitCC = function () {
      vm.model.ccBidDeadlineDate = vm.model.fcBidDeadlineDate;
      vm.model.ccBidDeadlineTime = vm.model.fcBidDeadlineTime;
    }

    vm.sameAsCockpitINS = function () {
      vm.model.insBidDeadlineDate = vm.model.fcBidDeadlineDate;
      vm.model.insBidDeadlineTime = vm.model.fcBidDeadlineTime;
    }

    vm.changeAny = function(type) {
      if(type == 'fcBidDeadlineDate' || type == 'fcBidDeadlineTime'){
        vm.model.ccSameAsCockpit = vm.model.ccBidDeadlineDate == vm.model.fcBidDeadlineDate && vm.model.ccBidDeadlineTime == vm.model.fcBidDeadlineTime;
        vm.model.insSameAsCockpit = vm.model.insBidDeadlineDate == vm.model.fcBidDeadlineDate && vm.model.insBidDeadlineTime == vm.model.fcBidDeadlineTime;
      }else if(type == 'ccBidDeadlineDate' || type == 'ccBidDeadlineTime'){
        vm.model.ccSameAsCockpit = vm.model.ccBidDeadlineDate == vm.model.fcBidDeadlineDate && vm.model.ccBidDeadlineTime == vm.model.fcBidDeadlineTime;
      }else if(type == 'insBidDeadlineDate' || type == 'insBidDeadlineTime'){
        vm.model.insSameAsCockpit = vm.model.insBidDeadlineDate == vm.model.fcBidDeadlineDate && vm.model.insBidDeadlineTime == vm.model.fcBidDeadlineTime;
      }
    }

    vm.onProceedClick = function () {
      var saveCycleReq = {
        cycleId : vm.model.cycleId,
        cycleName : vm.model.cycleName,
        dateFrom : vm.model.dateFrom,
        dateTo : vm.model.dateTo,
        fcBidDeadline : vm.model.fcBidDeadlineDate + ' ' + vm.model.fcBidDeadlineTime,
        ccBidDeadline : vm.model.ccBidDeadlineDate + ' ' + vm.model.ccBidDeadlineTime,
        insBidDeadline : vm.model.insBidDeadlineDate + ' ' + vm.model.insBidDeadlineTime,
        crewGroupCode : vm.model.crewGroupCode.split(',')[0],
        version : vm.model.version,
        operation : 'EDIT'
      }
      AdminCycleService
        .saveAdminCycle(
            saveCycleReq,
            function(response) {
              // if success
              if (response.success) {
                MessageService
                    .success('Admin Cycle is Successfully Updated!');
              } else if (!response.success) {
                MessageService.error(response.error);
              }
              $uibModalInstance.close(modalParams.close);
            }, function(error) {
              MessageService.error(error[0]);
              $uibModalInstance.close(modalParams.close);
            });
    };
  }
}());
